import RoundedCard from "./RoundedCard";
export default RoundedCard;
